import getConfiguration from '../../../../shared/src/rest/configurationRest';
import initSentry from '../../../../shared/src/utils/initSentry';
import initGoogleAnalytics from './initGoogleAnalytics';

/**
 * Initializing modules whose configuration is provided by the server.
 */
export default () => {
  getConfiguration().then((response) => {
    if (response.ok) {
      return response.json();
    }
    return {};
  }).then((configuration) => {
    initSentry(configuration);
    initGoogleAnalytics(configuration);
  });
};



// WEBPACK FOOTER //
// ./book/src/commons/config/initExternalDependencies.js